import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { toast } from 'react-toastify';

import AppContext from '../../../context/Context';
import { projectApi } from '../../../helpers/api/projectApi';
import { showErrorsFromRequest } from '../../../helpers/api/showErrorsFromRequest';
import {
  statusesWhenCollaboratorCanNotUpdateStatus,
  ProjectStatus,
  ProjectStatusText
} from '../../../helpers/enums/statusEnum';
import { getDefaultSelectValue } from '../../../helpers/utils/getDefaultSelectValue';
import { FormGroup, Input, Label } from 'reactstrap';

export default function ProjectStatusSelect({ projectId, status }) {
  const { t } = useTranslation();
  const { setFetchData, user } = useContext(AppContext);
  const [ sendEmailOnStatusChange, setSendEmailOnStatusChange ] = useState(false);

  const options = Object.keys(ProjectStatus)
    .filter((status) => user?.isAdmin || !statusesWhenCollaboratorCanNotUpdateStatus.includes(ProjectStatus[status]))
    .map((status) => {
      return {
        value: ProjectStatus[status],
        label: t(ProjectStatusText[ProjectStatus[status]])
      };
    });

  const handleStatusChange = async (option) => {
    if (option?.value !== status) {
      try {
        await projectApi.updateProjectStatus(projectId, option.value, sendEmailOnStatusChange);
        toast.success(t('Project status updated'));
        setFetchData(true);
      } catch (error) {
        showErrorsFromRequest(error, t);
      }
    }

    return null;
  };

  return (
    <div className="d-flex align-items-center gap-3">
      <Select
        options={options}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        onChange={(option) => handleStatusChange(option)}
        value={getDefaultSelectValue(status, options)}
        className="text-capitalize"
        styles={{
          menu: (base) => ({
            ...base,
            width: 'max-content',
            minWidth: '100%'
          })
        }}
      />
      <FormGroup check>
        <Label>
          <Input
            type="checkbox"
            checked={sendEmailOnStatusChange}
            onChange={(e) => setSendEmailOnStatusChange(e.target.checked)}
          />
          {t('Send email notification')}
        </Label>
      </FormGroup>
    </div>
  );
}
